export const Color = {
  Red: "#EF767A",
  Green: "#49BEAA",
  Blue: "#456990",
  Background: "#111922",
  Alternative: "#4a719b",
  OffWhite: "#E9E9E9",
};
